module.exports = __webpack_public_path__ + "img/security.6a066822.png";